module.exports = __webpack_public_path__ + "Roboto-LightItalic.1049664808142de0c45c.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/assets/font/roboto/Roboto-LightItalic.woff
// module id = ../../../../../src/assets/font/roboto/Roboto-LightItalic.woff
// module chunks = 2